import { gateAction } from "store/middleware/api"
import { loadViewData } from "store/modules/dataView/dataView-dataLoader"
import { printError } from "utils/printError"

export const deleteDynamoItemByPK = ({ PK, SK, goToList=null }) =>
  gateAction({
    op: "adminDelete",
    body: { pk: PK, sk: SK },
    onSuccess: (data, dispatch) => {
      goToList
        ?
        dispatch(goToList())
        :
        dispatch(loadViewData())
      return {
        type: "a"
      }
    },
    onFailure: (err) => {
      printError("deleteDynamoItemByPK()", err)
      // showMagicToaster({title: err})

      return {
        type: "a"
      }
    }
  })
